import React, { useEffect, useState }  from 'react';


const PreviewVerification = ({selectedValue, setSelectedValue}) => {
    const [inputCaptcha, setInputCaptcha] = useState('')
    const [keyArr, setKeyArr] = useState([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        'arrow',
        0,
        'chek'
    ])

    const hendlerSetInput = (e) => {
    
        if (typeof e === 'number') {
            setInputCaptcha(prev => prev + e.toString());
        } else if (e === 'arrow') {
            setInputCaptcha(prev => prev.slice(0, -1));
        }

    }

    // Classic Captcha
    // Images Captcha

    return (
        <div className='preview_verification_wrap'>
            <div className='preview_verification_header'>
                <img className='preview_verification_header_img' src="/img/BotAva.svg" alt="" />
                <h4>Themis</h4>
                <div className='preview_verification_header_lable'>
                    <img src="/img/check_white.svg" alt="" />
                    <p>BOT</p>
                </div>
                <p className='preview_verification_header_date'>Today at 15:36</p>
            </div>
            <div className='preview_verification_content'>
                <div className='preview_verification_captcha'>
                    <h4>Use the buttons below to complete this captcha</h4>
                    <div className='preview_verification_captcha_content'>
                        <p>Your Input:</p>
                        <input type="text" placeholder='64434' value={inputCaptcha} onChange={(e) => setInputCaptcha(e.target.value)}/>
                        <img src={`/img/captcha/${selectedValue}.png`} alt="" />
                        <p>Keyboard:</p>
                    </div>
                </div>
                <div className='preview_verification_keyboadr_wrap'>
                    {keyArr.map((item, idx) => (
                        <div 
                        key={idx} 
                        className='preview_verification_keyboadr_item'
                        onClick={(e) => hendlerSetInput(item)}
                        >
                            <img src={`/img/captcha/key/${item}.svg`} alt="" />
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default PreviewVerification;